import React from 'react';
import { Box, Typography } from '@material-ui/core';
import ImagePlaceholder from 'assets/img/placeholder/empty-state.svg';
import clsx from 'clsx';
import classes from './EmptyState.module.scss';

const EmptyState = ({
  className,
  hiddenImage,
  image = ImagePlaceholder,
  title,
  subTitle,
  ...props
}) => {
  return (
    <Box
      className={clsx(classes.emptyState, className)}
      flex={1}
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'>
      {!hiddenImage && <img src={image} alt='empty-state' />}

      <Box className={classes.wrapperText}>
        <Typography variant='h3' className={classes.title}>
          {title}
        </Typography>
        <Typography variant='subtitle1' className={classes.subtitle}>
          {subTitle}
        </Typography>
      </Box>
      {props.children}
    </Box>
  );
};

export default EmptyState;
